import { render } from "./HighlightedInfo.vue?vue&type=template&id=1c49a1ea"
import script from "./HighlightedInfo.vue?vue&type=script&lang=js"
export * from "./HighlightedInfo.vue?vue&type=script&lang=js"

import "./HighlightedInfo.vue?vue&type=style&index=0&id=1c49a1ea&lang=scss"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__